// Champion ("legend" in the sim) strings — Spanish. Merged in ./messages.ts.

import type { gameLegendsEn } from './gameLegendsEn.js';

export const gameLegendsEs: Record<keyof typeof gameLegendsEn, string> = {
  'champion.title': 'Campeón',
  'champion.kind.dragon': 'Dragón',
  'champion.level': 'Nivel {level}/{max}',
  'champion.kills': '{kills} bajas',
  'champion.nextLevel': 'Siguiente nivel a las {kills} bajas',
  'champion.maxLevel': 'Nivel máximo',
  'champion.hp': 'Salud',
  'champion.rival': 'Campeón rival',
  'champion.ability.firestorm': 'Tormenta de fuego',
  'champion.ability.firestormHint':
    'Lluvia de fuego sobre una casilla a hasta {range} casillas (radio {radius}).',
  'champion.ability.ready': 'Listo',
  'champion.ability.cooldown': 'Recargando {seconds}s',
  'champion.ability.targeting': 'Elige una casilla objetivo (Esc para cancelar)',
  'champion.ability.cancel': 'Cancelar',
  'champion.err.on_cooldown': 'Aún se está recargando.',
  'champion.err.out_of_range': 'El objetivo está fuera de alcance.',
  'champion.err.not_owner': 'No es tu Campeón.',
  'champion.err.not_a_legend': 'Esa unidad no es un Campeón.',
  'champion.err.no_such_slot': 'No existe esa habilidad.',
  'champion.err.module_off': 'Los Campeones están desactivados en esta partida.',
  'champion.err.unavailable': 'La simulación no está lista.',
  'champion.err.rejected': 'Se rechazó la habilidad.',
  'champion.hint.notAtWar':
    'No alcanzó a nadie: esas unidades son de un jugador con el que no estás en guerra. Las habilidades de Campeón solo afectan a enemigos en guerra contigo o a bandidos.',
  'champion.summon.title': 'Invocar Campeón',
  'champion.summon.blurb':
    'Un Campeón acude al llamado de una gran ciudad. Solo un Campeón a la vez.',
  'champion.summon.button': 'Invocar {kind}',
  'champion.site.dragon_roost': 'Guarida del Dragón',
  'champion.summon.cost': 'Coste: {gold} de oro, {rare} de maná, {pop} de población.',
  'champion.summon.costFaith': 'Coste: {gold} de oro, {rare} de fe, {pop} de población.',
  'champion.summon.recost': 'Nueva invocación al {pct}% del coste original.',
  'champion.summon.progress': 'Invocando... {pct}%',
  'champion.summon.eta': 'Faltan {time}',
  'champion.summon.elsewhere': 'Se está invocando un Campeón en otra ciudad.',
  'champion.summon.alive': 'Tu Campeón recorre el reino. Selecciónalo en el mapa.',
  'champion.summon.fallen': 'Tu Campeón ha caído. Podrás invocarlo de nuevo en {time}.',
  'champion.summon.requirements': 'Requisitos',
  'champion.req.available': 'Ningún Campeón activo',
  'champion.req.doctrine': 'Doctrina {doctrines} de nivel {need} (ahora {have})',
  'champion.req.cityTier': 'Ciudad de nivel {need} o superior (ahora {have})',
  'champion.req.cityTierFirst': 'Ciudad de nivel {need} o superior (solo la primera invocación)',
  'champion.req.site': '{site} construida en esta ciudad',
  'champion.req.pop': 'Población de la ciudad {have} / {need}',
  'champion.req.gold': 'Oro {have} / {need}',
  'champion.req.rare': 'Maná {have} / {need}',
  'champion.req.rareFaith': 'Fe {have} / {need}',
  'champion.block.available': 'Ya hay un Campeón activo o recuperándose.',
  'champion.block.doctrine': 'Requiere una doctrina {doctrines} más alta.',
  'champion.block.cityTier': 'Esta ciudad es demasiado pequeña.',
  'champion.block.site': 'Construye primero {site} aquí.',
  'champion.block.pop': 'Esta ciudad no tiene suficiente población.',
  'champion.block.gold': 'No hay suficiente oro.',
  'champion.block.rare': 'No hay suficiente maná.',
  'champion.block.rareFaith': 'No hay suficiente fe.',
  'champion.summon.err.cannot_afford': 'No hay suficiente maná o fe para la invocación.',
  'champion.summon.err.no_summoning_site': 'Construye primero el sitio de invocación aquí.',
  'champion.summon.err.city_too_small': 'Esta ciudad es demasiado pequeña.',
  'champion.summon.err.doctrine_locked': 'Requiere una doctrina más alta.',
  'champion.summon.err.not_available': 'Ya hay un Campeón activo o recuperándose.',
  'champion.summon.err.not_owner': 'No es tu ciudad.',
  'champion.summon.err.rejected': 'Se rechazó la invocación.',
  'event.legendSummonStarted': 'Invocación de Campeón',
  'event.legendFirestorm': 'Tormenta de fuego',
  'event.legendSummoned': 'Campeón invocado',
  'event.legendFallen': 'Campeón caído',
  'event.detail.legendSummonStarted': 'El jugador {player} inicia una invocación',
  'event.detail.legendFirestorm': '{hits} alcanzados, {kills} abatidos',
  'event.detail.legendSummoned': 'Jugador {player}: ha llegado el {kind}',
  'event.detail.legendFallen': 'Jugador {player}: regresa en {seconds}s',
};
